<template>
  <div class="footers">
    <div class="c-w1200 footers-cont">
      <dl>
        <dt><img src="@/assets/img/footer-logo.png" alt="" /></dt>
        <dd>
          <p>
            Copyright © 2023 kangtao Technology. All Rights Reserved.
            康陶科技&nbsp;&nbsp;版权所有
          </p>
          <p>
            邢台康陶信息技术服务有限公司&nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn/" target="_blank">{{
              beiAnNum
            }}</a>
            &nbsp;&nbsp;
            <a
              :href="`https://beian.mps.gov.cn/#/query/webSearch?code=${getNumbersInString(
                mpsBeiAnNum
              )}`"
              target="_blank"
            >
              <img
                src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png"
                alt=""
                srcset=""
                width="12"
                style="margin-right: 3px"
              />{{ mpsBeiAnNum }}</a
            >
          </p>
        </dd>
      </dl>
      <ul>
        <li>
          <!-- <img src="@/assets/img/abt_Applets.jpg" alt="" />
          <p>康陶安保通小程序</p> -->
        </li>
        <li>
          <img src="@/assets/img/public.jpg" alt="" />
          <p>康陶云公众号</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  beiAnList,
  beiAnBase,
  mpsBeiAnList,
  mpsBeiAnBase,
} from "@/constants/common";

let mpsBeiAnNum = mpsBeiAnBase;
let beiAnNum = beiAnBase;
for (let key of Object.keys(beiAnList)) {
  if (window.location.origin.includes(key)) {
    beiAnNum = beiAnList[key];
    mpsBeiAnNum = mpsBeiAnList[key];
    break;
  }
}

export default {
  name: "commonFooters",
  data() {
    return {
      beiAnNum,
      mpsBeiAnNum,
    };
  },
  methods: {
    getNumbersInString(string) {
      return string.match(/\d+/g);
    },
  },
};
</script>

<style scoped>
@import url("../assets/css/common.css");
.footers {
  background: #fff;
}
.footers-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 35px 0;
}
.footers-cont dl,
.footers-cont ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.footers-cont dl {
  width: 75%;
}
.footers-cont ul {
  width: 20%;
}
.footers-cont dl dt {
  height: 60px;
}
.footers-cont dl dt img {
  height: 100%;
}
.footers-cont dl dd {
  display: flex;
  height: 40px;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 8%;
}
.footers-cont dl dd p {
  color: #555555;
  font-size: 14px;
}
.footers-cont ul li {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 10%;
}
.footers-cont ul li:last-child {
  margin-right: 0 !important;
}
.footers-cont ul li img {
  width: 80px;
  margin-bottom: 10px;
}
.footers-cont ul li p {
  color: #555555;
  font-size: 12px;
}
</style>
